export const SINGLE_SPRINT_REQUEST = "singleSprint/singleSprintRequest";
export const SINGLE_SPRINT_SUCCESS = "singleSprint/singleSprintSuccess";
export const SINGLE_SPRINT_ERROR = "singleSprint/singleSprintError";